import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { generarCasoEspecial, getCasosAsistente, getHistorialCaso, getTipoCaso, modificarCasoEspecial, reenvioCasoEspecial, updateFoto } from "Services/casos_services";
import { setResponse } from "Slices/Response/responseSlice";
import { setLoading, setShowBackdrop, setToast } from "Slices/uiSlice";
import { fileUri } from "Constantes/constants";
import { uploadFileS3 } from "Services/file_service";

const initialState = {
    tipoCaso: [],
    incidencias: [],
    casosEspeciales: [],
    casoSoporte: {
        idTipoCaso: -1,
        incidencia: -1,
        descripcion: '',
        clientes: null,
        fechaIncidencia: null,
        fotoIncidencia: null,
        fotoClientes: null
    },
    historialCaso: [],
}

const uploadFotoS3 = async (file, nombre, tipo) => {
    const formData = new FormData();
    formData.append('file', file, nombre);
    formData.append('tipo', tipo);
    return await uploadFileS3(formData);
}

export const casosEspecialesSlice = createSlice({
    name: 'casosEspeciales',
    initialState,
    reducers: {
        setTipoCaso: (state, action) => {
            state.tipoCaso = action.payload;
        },
        setIncidencias: (state, action) => {
            state.incidencias = action.payload;
        },
        setCasosEspeciales: (state, action) => {
            state.casosEspeciales = action.payload;
        },
        setCasoSoporte: (state, action) => {
            state.casoSoporte = action.payload;
        },
        setHistorialCaso: (state, action) => {
            state.historialCaso = action.payload;
        }

    }
});

export const fetchTipoCaso = createAsyncThunk(
    'casosEspeciales/fetchTipoCaso',
    async (data, { dispatch }) => {
        const tipoCasoRes = await getTipoCaso(data);
        await dispatch(setTipoCaso(tipoCasoRes));
        await dispatch(setIncidencias(tipoCasoRes[0].opciones));
        await dispatch(setCasoSoporte({
            idTipoCaso: tipoCasoRes[0]?.idTipoCaso,
            incidencia: tipoCasoRes.find(tc => tc.idTipoCaso === tipoCasoRes[0].idTipoCaso)?.opciones[0].idTipoCaso,
        }));
    }
);

export const CrearCaso = createAsyncThunk(
    'casosEspeciales/create',
    async (data, { dispatch }) => {
        let res;
        dispatch(setShowBackdrop(true));
        try {
            const responseCaso = await generarCasoEspecial(data);
            dispatch(setResponse(responseCaso));

            if (responseCaso?.result) {
                const idCaso = responseCaso.data;
                const nombreInc = `${idCaso}-inc.jpg`;
                const nombreCli = `${idCaso}-cli.jpg`;

                await uploadFotoS3(data.fotoIncidencia, nombreInc, fileUri.casos);
                await updateFoto({ idCaso, fotoIncidencia: nombreInc });

                await uploadFotoS3(data.fotoClientes, nombreCli, fileUri.casos);
                await updateFoto({ idCaso, fotoClientes: nombreCli });

                dispatch(setCasoSoporte(null));
                res = responseCaso;
            }
        } catch (error) {
            dispatch(setResponse({ result: -1, message: 'Ocurrió un error al procesar el caso, por favor intentalo de nuevo' }));
        } finally {
            dispatch(setToast(true));
            setTimeout(() => {
                dispatch(setToast(false));
            }, 5000);
            dispatch(setShowBackdrop(false));
        }
        return res;
    }
);

export const UpdateCaso = createAsyncThunk(
    'casosEspeciales/update',
    async (data, { dispatch }) => {
        dispatch(setShowBackdrop(true));
        const responseCaso = await modificarCasoEspecial(data);
        dispatch(setCasoSoporte(null));
        dispatch(setResponse(responseCaso));
        dispatch(setToast(true));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
        dispatch(setShowBackdrop(false));
    }
);

export const ReenviarCaso = createAsyncThunk(
    'casosEspeciales/create',
    async (data, { dispatch }) => {
        let res;
        dispatch(setShowBackdrop(true));
        try {
            const responseCaso = await reenvioCasoEspecial(data);
            dispatch(setResponse(responseCaso));

            if (responseCaso?.result) {
                const idCaso = responseCaso.data;
                const nombreInc = `${idCaso}-inc.jpg`;
                const nombreCli = `${idCaso}-cli.jpg`;

                await uploadFotoS3(data.fotoIncidencia, nombreInc, fileUri.casos);
                await updateFoto({ idCaso, fotoIncidencia: nombreInc });

                await uploadFotoS3(data.fotoClientes, nombreCli, fileUri.casos);
                await updateFoto({ idCaso, fotoClientes: nombreCli });

                dispatch(setCasoSoporte(null));
                res = responseCaso;
            }
        } catch (error) {
            dispatch(setResponse({ result: -1, message: 'Ocurrió un error al procesar el caso, por favor intentalo de nuevo' }));
        } finally {
            dispatch(setToast(true));
            setTimeout(() => {
                dispatch(setToast(false));
            }, 5000);
            dispatch(setShowBackdrop(false));
        }
        return res;
    }
);

export const fetchHistorialCaso = createAsyncThunk(
    'casosEspeciales/fetchHistorial',
    async (data, { dispatch }) => {
        const historialRes = await getHistorialCaso(data);
        dispatch(setHistorialCaso(historialRes));
    }
);


export const fetchCasosEspeciales = createAsyncThunk(
    'casosEspeciales/fetchCasos',
    async (data, { dispatch }) => {
        dispatch(setLoading(true));
        const casosRes = await getCasosAsistente(data);
        dispatch(setCasosEspeciales(casosRes ?? []));
        dispatch(setLoading(false));
    }
);

export const { setTipoCaso, setIncidencias, setCasosEspeciales, setCasoSoporte, setHistorialCaso } = casosEspecialesSlice.actions;
export default casosEspecialesSlice.reducer;